import React from "react";
import Dialog from "@material-ui/core/Dialog";
import { DialogActions,DialogTitle, DialogContent } from "../../../Utils/Dialog/pharmacyDialog";

const AccountsPayableDialog = ({handleCloseAccountsDialog,handleClose,openAccountsPayableDialog,handleOpenReceiptDialog,message,text}) => {

    return (
        <Dialog open={openAccountsPayableDialog}>
            <DialogTitle onClose={handleCloseAccountsDialog}>
                <div className="text-center">
                    View {message}
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="text-center">
                    <p style={{fontSize:"14px"}}>Would you like to view the {text ? text : 'invoice'}?</p>
                </div>
            </DialogContent>
            <DialogActions>
                <div className="text-right">
                    <button onClick={handleOpenReceiptDialog} type="button" className="btn pharmacy-info-btn mr-3">Yes</button>
                    
                        <button type="button" onClick={handleClose} className="btn pharmacy-grey-btn ">No</button>
                    
                </div>
            </DialogActions>
        </Dialog>
    )

};
export default AccountsPayableDialog;